import React from 'react';
import { useSelector } from 'react-redux';

import { crossLinksSelector } from './utils/selectors';
import { SeoCrossLinks } from '../../components/SeoCrossLinks';

export function SeoCrossLinksContainer() {
  const crossLinks = useSelector(crossLinksSelector);

  if (!crossLinks || !crossLinks.length) {
    return null;
  }

  return <SeoCrossLinks seoBlocks={crossLinks} />;
}
